function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-v-1cd49c1e": "",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  "data-v-1cd49c1e": "",
  transform: "translate(0.000000, -1612.000000)",
  fill: "rgba(0,0,0,0.5)"
}, React.createElement("g", {
  "data-v-1cd49c1e": "",
  transform: "translate(0.000000, 1612.000000)"
}, React.createElement("path", {
  "data-v-1cd49c1e": "",
  d: "M0,0 L375,0 L375,490 L0,490 L0,0 Z M174.665502,312.622085 L138.839719,312.622085 L138.839719,84 C119.634144,84.7620736 82.7003476,86.2862209 56.4773519,88.1914049 L56.4773519,97.3362883 L94.1498246,97.3362883 L94.1498246,312.622085 L55,312.622085 L55,321.766969 L174.665502,321.766969 L174.665502,312.622085 Z M257.766545,325.577337 C306.888494,325.577337 319.815323,238.319908 320.184661,204.788668 C320.553999,158.683215 303.195115,84 257.766545,84 C212.337974,84 194.97909,158.683215 195.348428,204.407632 C195.717766,238.319908 208.644595,325.577337 257.766545,325.577337 Z"
}), React.createElement("path", {
  "data-v-1cd49c1e": "",
  d: "M274.386753,125.533012 C274.386753,104.194951 271.062711,92.001773 257.766545,92.001773 C244.10104,92.001773 240.776998,104.194951 240.776998,125.533012 L240.776998,285.187435 C240.776998,306.14446 246.686405,317.575564 257.766545,317.575564 C268.477346,317.575564 274.386753,306.14446 274.386753,285.187435 L274.386753,125.533012 Z"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    "data-v-1cd49c1e": "",
    "data-v-59251244": "",
    width: "375px",
    height: "490px",
    viewBox: "0 0 375 490",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/mask10.61f92d61.svg";
export { SvgComponent as ReactComponent };